export default __webpack_public_path__ + "static/char-41-b25dc010c6949ccbade3cf471485485f.webp";